import React from 'react';
import PropTypes from 'prop-types';

import { reduxForm, Field } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';

import Button from 'components/common/Button';
import TextField from 'components/fields/TextField';

import * as normalize from 'utils/normalize';
import * as validate from 'utils/validate';

const styles = () => ({
  root: {
    width: 160,
  },
  button: {
    display: 'block',
    width: '100%',
    marginTop: 24,
  },
});

const validateForm = (values) => {
  const errors = {};

  if (values['Split for Claim'] && Number(values['Split for Claim']) > 6) {
    errors['Split for Claim'] = 'Maximum number of splits is 6';
  }

  return errors;
};

const ProductClaimSplitForClaimForm = ({
  handleSubmit,
  submit,
  classes,
}) => (
  <form
    className={classes.root}
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
  >
    <Field
      id="Split for Claim"
      name="Split for Claim"
      label="Number of Order Lines"
      component={TextField}
      validate={[validate.required]}
      normalize={normalize.positiveNumber}
      fullWidth
    />
    <Button
      className={classes.button}
      variant="raised"
      color="primary"
      onClick={() => { submit(); }}
    >
      Done
    </Button>
  </form>
);

ProductClaimSplitForClaimForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
  }).isRequired,
};

export default reduxForm({
  onSubmit: values => values,
  validate: validateForm,
  enableReinitialize: true,
})(withStyles(styles)(ProductClaimSplitForClaimForm));



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaim/ProductClaimSplitForClaimForm.js